import React from "react"

const BlankPage: React.FC = () => {
  return (
    <div>
      <h1>빈 페이지</h1>
      <p>이것은 새로운 빈 페이지입니다.</p>
    </div>
  )
}

export default BlankPage
